import { AppData, Lightning, Log, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup';
import { Helper } from '../lib/helper';

export interface CCItemContentTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  Label: object
  Checkmark: object
}

export default class CCItemContent
  extends Lightning.Component<CCItemContentTemplateSpec>
  implements Lightning.Component<CCItemContentTemplateSpec> {
  selected = false
  content = ''
  itemIndex = 0
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<CCItemContentTemplateSpec> {
    return {
      Wrapper: {
        w: (w: any) => w,
        h: (h: any) => h,
        rect: true,
        color: 0x00000000,
        collision: true,
        zIndex: 42,
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 5 },
        Label: {
          x: 25,
          y: (h: any) => h / 2,
          mountY: 0.5,
          // collision: true,
          text: {
            text: "",
            fontSize: 28,
            textColor: 0xffffffff,
            fontFace: Helper.getFontFamily('Black')
          },
        },
        Checkmark: {
          x: (w: any) => w - 50,
          y: (h: any) => h / 2,
          mountY: 0.5,
          alpha: 0,
          texture: {
            type: Lightning.textures.ImageTexture,
            src: Utils.asset('images/tick.png'),
            resizeMode: {
              h: 28,
              w: 28,
              type: 'contain',
            }
          }
        }
      }
    }
  }

  override _handleEnter() {
    this.fireAncestors('$optionSelected' as any, this.itemIndex)
    return true
  }

  update() {
    const isFocused = this.hasFocus()
    const isSelected = this.selected

    const bgColor = isFocused ? 0xffffffff : 0x00000000
    const targetTextColor = isFocused ? 0xff000000 : 0xffffffff;
    const src = isFocused ? Utils.asset('images/tick_focus.png') : Utils.asset('images/tick.png');

    (this.tag('Label') as any).setSmooth('text.textColor', targetTextColor);
    (this.tag('Checkmark') as any).patch({ texture: { src : src }})

    this.tag('Checkmark')!.alpha = isSelected ? 1 : 0
    this.tag('Wrapper')!.setSmooth('color', bgColor)
  }

  override _focus() {
    this.update()
  }

  override _unfocus() {
    this.update()
  }

  set itemSelected(itemSelected: any) {
    this.selected = itemSelected || false
    Log.info('CCItemContent itemSelected: ', this.selected)
    this.update()
  }

  set item(itemInfo: any) {
    Log.info('CCItemContent setItem: ', itemInfo.name)
    this.tag('Label')!.text.text = itemInfo.name
  }

  _handleClick(target: any) {
    console.log('CCItemContent _handleClick : ', target, this.itemIndex)
    this.fireAncestors('$optionSelected', this.itemIndex)
  }

  _handleHover(target: any) {
    this.fireAncestors('$OptionHovered' as any, this.itemIndex)
  }

}